import React, {Fragment, useContext, useMemo} from "react";
import {Layer, MapContext, Source} from "react-mapbox-gl";
import {useMapVisibility} from "../hooks/mapHooks";


export function ChangeImagery(props) {
    const map = useContext(MapContext)

    const compare = (visibility) => {
        return visibility === 'visible' ? 1 : 0
    }
    const {activeChange, changes} = props;
    if (!changes) {
        return null
    }
    const layerId = 'layer_id2'
    const afterLayerId = 'layer_id'
    useMapVisibility({map, layerId, afterLayerId, compare})

    const RASTER_SOURCE_OPTIONS = {
        "type": "raster",
        "tiles": [activeChange.properties['cd:before_tile_id'],
        ],
        "tileSize": 256
    };

    const RASTER_SOURCE_OPTIONS2 = {
        "type": "raster",
        "tiles": [activeChange.properties['cd:after_tile_id']],
        "tileSize": 256

    };
    return useMemo(() => (
        <Fragment>
            <Source id="source_id2" tileJsonSource={RASTER_SOURCE_OPTIONS2}/>
            <Layer type="raster" id="layer_id2" sourceId="source_id2"
                   layout={{'visibility': 'visible'}}/>
            {/*<Layer type="raster" id="layer_id2" sourceId="source_id2" paint={{'raster-opacity': visibility==='visible'}}/>*/}
            <Source id="source_id" tileJsonSource={RASTER_SOURCE_OPTIONS}/>
            <Layer type="raster" id="layer_id" sourceId="source_id"
                   layout={{'visibility': 'visible'}}/>
        </Fragment>), [changes])


}



// WEBPACK FOOTER //
// ./src/components/ChangeImagery.js